(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;
    var targetUrl =
      "https://pcl325puzphyaitbkt4ic6ev.fast.sparq.ai/v2".toLowerCase();

    if (url && url.toLowerCase() === targetUrl) {
      const body = JSON.parse(data);

      if (
        !body.textFacetFilters ||
        Object.keys(body.textFacetFilters).length === 0
      ) {
        if (
          location.pathname === "/collections/all" &&
          body.query.length === 0
        ) {
          body.groupCount = -1;
          body.groupBy = "productId";
        } else {
          body.groupCount = -1; // Adjust this value as per your requirement
          delete body.groupBy;
        }
      } else {
        body.groupCount = -1; // Adjust this value as per your requirement
        delete body.groupBy;
      }
      if (!body.textFacetFilters.option_auto_size && !body.query) {
        body.textFacetFilters.option_auto_size = ["22 oz", "32 oz"];
      }
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.addEventListener("load", () => {
  if (window.innerWidth < 767) {
    let dropdown = document.querySelector(".sq-dropdown-body");
    let searchContainer = document.querySelector(".search-container");
    searchContainer.append(dropdown);
  }
});

window.sq.initSearch = (store) => {
  store.search();
};

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
}, 200);

//close dropdown on esc
window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    // escape key maps to keycode `27`
    document.querySelector("footer").click();
  }
});

// window.sq.getHandle = function (item, filters) {
//   performance.mark("getHandle.start");

//   const selectedOption1 = filters
//     ?.find((filter) => filter.stFieldName === "option_auto_color")
//     ?.items?.find((item) => item.selected)?.label;

//   if (selectedOption1) {
//     const matchingVariant = item.variants.find(
//       (x) => x.option1.toLowerCase() === selectedOption1.toLowerCase()
//     );
//     if (matchingVariant) {
//       // if (matchingVariant && matchingVariant.inventory_quantity > 0) {
//       item.customHandle = `/products/${item.handle}?variant=${matchingVariant?.id}`;
//       let selectedImage = item.images.filter(
//         (x) => x.id === matchingVariant.image_id
//       );
//       console.log("item",item.image)
//       item.image = selectedImage[0];
//       return item;
//     }
//   }

//   return item;
// };

// window.sq.getHandle = function (item, filters) {
//   performance.mark("getHandle.start");

//   const selectedColor = filters.find(filter => filter.stFieldName === "option_auto_color")?.items?.find(item => item.selected)?.label;

//   if (!selectedColor) {
//     return item?.image?.src;
//   }

//   const matchingVariant = item.variants.find(x =>
//     (x.option1?.toLowerCase() === selectedColor.toLowerCase() ||
//      x.option2?.toLowerCase() === selectedColor.toLowerCase())
//   );

//   if (matchingVariant) {
//     return item.images.find(image => image.id === matchingVariant.image_id)?.src;
//   }
// };

window.sq.getHandle = function (item, filters) {
  performance.mark("getHandle.start");
  const selectedColor = filters
    .find((filter) => filter.stFieldName === "option_auto_color")
    ?.items?.find((item) => item.selected)?.label;

  if (selectedColor) {
    const matchingVariant = item.variants.find(
      (x) =>
        x.option2.toLowerCase() === selectedColor.toLowerCase() ||
        x.option1.toLowerCase() === selectedColor.toLowerCase()
    );
    if (matchingVariant && matchingVariant.inventory_quantity > 0) {
      item.customHandle = `/products/${item.handle}?variant=${matchingVariant?.id}`;

      let selectedImage = item.images?.filter(
        (x) => x?.id === matchingVariant.image_id
      );
      item.images[0] = selectedImage[0];
      return item;
    }
  }

  return item;
};

window.sq.data = function (store) {
  const titles22 = store.results.filter((item) => item.title.startsWith("22 Oz"));
  const titles32 = store.results.filter((item) => item.title.startsWith("32 Oz"));
  console.log(titles22);
  return [...titles22,...titles32];
};
